import React, {useState} from 'react';
import {useTranslation} from "react-i18next";
import ErrorFormAlertView from "../../../components/Common/ErrorFormAlertView";
import ErrorFormHelper from "../../../utils/ErrorFormHelper";
import ErrorFormView from "../../../components/Common/ErrorFormView";
import {api} from "../../../services/Api/api";
import IframeWidget from "../../../utils/IframeWidget";
import PopupModal from "../../../components/Modal/PopupModal";

interface Props {
    order: any,
    onHide: () => void,
    onSuccess: (data: any) => void
}

const SummaryCancelModal = (props: Props) => {
    const {t} = useTranslation();
    const [cancelReason, setCancelReason] = useState("");
    const [cancelErrors, setCancelErrors] = useState<any[]>([]);
    const [cancelLoading, setCancelLoading] = useState(false);

    const cancel = async () => {
        setCancelLoading(false);
        try {
            const data = await api.cancelOrder(props.order.id, props.order.token, cancelReason);
            props.onSuccess(data);
            IframeWidget.onHide(props.onHide)
        } catch (error: any) {
            setCancelLoading(false);
            setCancelErrors(error.errors);
        }
    }
    const handleChangeCancelReason = (event: any) => {
        setCancelReason(event.target.value as any);
    }

    return <PopupModal
        title={t("modules.cancel_order_modal.header.title")}
        show
        onHide={props.onHide}
        cancelButton
        bodyContent={
            <div>
                <ErrorFormAlertView errors={cancelErrors}/>
                <div className="form-group">
                    <input type="text" value={cancelReason}
                           onChange={handleChangeCancelReason}
                           className={"form-control" + ErrorFormHelper(cancelErrors, "cancel_reason")}
                           id="street"
                           placeholder={t("modules.cancel_order_modal.field.cancel_reason.title")}/>
                    <label
                        htmlFor="street">{t("modules.cancel_order_modal.field.cancel_reason.title")}</label>
                    <ErrorFormView errors={cancelErrors} field="cancel_reason"/>
                </div>
            </div>
        }
        primaryButton={
            <button
                className={"btn-spinner btn-block btn-danger btn btn-submit" + (cancelLoading ? ' loading' : '')}
                onClick={cancel}>
                <span className="left spinner-border spinner-border-sm"/>
                {t("common.action.cancel_order")}
            </button>
        }
    />
}
export default SummaryCancelModal;